"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GAUGE_CHART_SETTINGS = void 0;
var GAUGE_CHART_SETTINGS = {};
exports.GAUGE_CHART_SETTINGS = GAUGE_CHART_SETTINGS;